import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "nav_article"
};

var _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "选靓号", -1);

var _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "选套餐", -1);

var _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "个性定制", -1);

var _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "查订单", -1);

var _hoisted_11 = /*#__PURE__*/_createTextVNode("清空条件");

var _hoisted_12 = {
  style: {
    "margin-top": "0.1rem",
    "margin-bottom": "1.56rem"
  }
};
var _hoisted_13 = {
  class: "phone_number_article"
};
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
  class: "liang_phonenumber"
};
var _hoisted_16 = ["innerHTML"];
var _hoisted_17 = {
  key: 0,
  class: "liang_flag"
};
var _hoisted_18 = {
  class: "opt_Id"
};
var _hoisted_19 = {
  key: 0
};
var _hoisted_20 = {
  key: 1
};
var _hoisted_21 = {
  key: 2
};
var _hoisted_22 = {
  key: 3
};
var _hoisted_23 = {
  key: 4
};
var _hoisted_24 = {
  class: "price"
};
var _hoisted_25 = {
  key: 0,
  style: {
    "text-align": "center",
    "font-size": "0.18rem",
    "margin": "0.5rem",
    "color": "#c2c2c2"
  }
};

var _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, "数据加载中，请耐心等待...", -1);

var _hoisted_27 = {
  class: "copyright"
};

var _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "版权所有：杭州我爱号码网电子商务有限公司", -1);

var _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "联系电话：0571-28888520", -1);

var _hoisted_30 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
var _hoisted_31 = {
  key: 0
};
var _hoisted_32 = {
  key: 1
};
var _hoisted_33 = {
  key: 2
};
var _hoisted_34 = {
  key: 3
};
var _hoisted_35 = {
  key: 4
};
var _hoisted_36 = {
  class: "order_div"
};
var _hoisted_37 = {
  class: "subject1"
};
var _hoisted_38 = {
  class: "liang_phonenumber1"
};

var _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-area1"
}, null, -1);

var _hoisted_40 = {
  class: "text1"
};
var _hoisted_41 = {
  class: "text1"
};
var _hoisted_42 = {
  key: 0,
  class: "text1"
};
var _hoisted_43 = {
  key: 1,
  class: "text1"
};
var _hoisted_44 = {
  key: 2,
  class: "text1"
};
var _hoisted_45 = {
  key: 3,
  class: "text1"
};
var _hoisted_46 = {
  key: 4,
  class: "text1"
};
var _hoisted_47 = {
  class: "packageTable"
};

var _hoisted_48 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "开户套餐", -1);

var _hoisted_49 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "月费", -1);

var _hoisted_50 = {
  key: 0
};

var _hoisted_51 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "优惠", -1);

var _hoisted_52 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "套餐内", -1);

var _hoisted_53 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "套餐外", -1);

var _hoisted_54 = {
  key: 1
};

var _hoisted_55 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "合约", -1);

var _hoisted_56 = {
  key: 0
};

var _hoisted_57 = /*#__PURE__*/_createTextVNode("号码月保底消费");

var _hoisted_58 = {
  class: "red"
};

var _hoisted_59 = /*#__PURE__*/_createTextVNode("元");

var _hoisted_60 = {
  key: 1
};

var _hoisted_61 = /*#__PURE__*/_createTextVNode("号码要求在网时长");

var _hoisted_62 = {
  class: "red"
};

var _hoisted_63 = /*#__PURE__*/_createTextVNode("个月");

var _hoisted_64 = /*#__PURE__*/_createElementVNode("div", {
  class: "order_info1"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*"), /*#__PURE__*/_createTextVNode("请务必填写正确的入网信息"), /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*")], -1);

var _hoisted_65 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ");

var _hoisted_66 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《入网协议》", -1);

var _hoisted_67 = /*#__PURE__*/_createTextVNode(" 和 ");

var _hoisted_68 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《关于客户个人信息收集、使用规则的公告》", -1);

var _hoisted_69 = {
  key: 0
};

var _hoisted_70 = /*#__PURE__*/_createTextVNode("和 ");

var _hoisted_71 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《靓号入网补充协议》", -1);

var _hoisted_72 = [_hoisted_70, _hoisted_71];

var _hoisted_73 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《中国电信用户入网协议（2024线上版）》", -1);

var _hoisted_74 = /*#__PURE__*/_createTextVNode(" 和 ");

var _hoisted_75 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《法律风险告知书》", -1);

var _hoisted_76 = [_hoisted_73, _hoisted_74, _hoisted_75];

var _hoisted_77 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《中国广电移动电话通信业务入网服务协议（V1.0）》", -1);

var _hoisted_78 = [_hoisted_77];

var _hoisted_79 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《中国移动通信客户服务协议》", -1);

var _hoisted_80 = /*#__PURE__*/_createTextVNode(" 和");

var _hoisted_81 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《实名制信息安全责任告知书》", -1);

var _hoisted_82 = /*#__PURE__*/_createTextVNode(" 和");

var _hoisted_83 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《关于客户个人信息收集、使用及保护的公告》", -1);

var _hoisted_84 = [_hoisted_79, _hoisted_80, _hoisted_81, _hoisted_82, _hoisted_83];
var _hoisted_85 = {
  class: "pay_div"
};
var _hoisted_86 = {
  class: "content"
};
var _hoisted_87 = {
  style: {
    "font-size": "0.26rem"
  }
};

var _hoisted_88 = /*#__PURE__*/_createTextVNode("合计：");

var _hoisted_89 = {
  class: "red"
};

var _hoisted_90 = /*#__PURE__*/_createTextVNode(" 价格明细 ");

var _hoisted_91 = /*#__PURE__*/_createTextVNode("立即预约");

var _hoisted_92 = {
  class: "fee_detail"
};
var _hoisted_93 = {
  style: {
    "width": "100%",
    "border-bottom": "0.01rem solid #cccccc"
  }
};

var _hoisted_94 = /*#__PURE__*/_createElementVNode("span", null, "服务费", -1);

var _hoisted_95 = {
  style: {
    "width": "100%"
  }
};

var _hoisted_96 = /*#__PURE__*/_createElementVNode("span", null, "话费", -1);

var _hoisted_97 = /*#__PURE__*/_createElementVNode("div", {
  class: "buy_know"
}, [/*#__PURE__*/_createElementVNode("h4", null, "购买须知"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "border": "0.01rem solid #ffffff"
  }
}), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "1、"), /*#__PURE__*/_createTextVNode("根据工信部2018年9月1日实名新规要求，您下单时需填写真实姓名和身份证号进行实名认证，电话卡收到后需激活才能使用。激活时需上传身份证正面、反面以及本人正面免冠照片，下单填写的姓名和身份证信息需要与实名登记的信息一致，审核通过后才能激活使用。 ")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "2、"), /*#__PURE__*/_createTextVNode("预约订单提交成功后，系统会进行购买资格审核认证，认证通过会进行正式单下单然后制卡发货。认证失败将会全额退款。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "3、"), /*#__PURE__*/_createTextVNode("号码制卡成功发货后激活前退单请联系客服协商能否退款。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "4、"), /*#__PURE__*/_createTextVNode("由于手机号码属于一卡一号，一旦售出完成实名制激活后无法进行退换货，请谨慎购买。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "5、"), /*#__PURE__*/_createTextVNode("请保持手机畅通以便于工作人员随时联系到您。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "6、"), /*#__PURE__*/_createTextVNode("若需开具发票，请联系客服。本司仅开取服务费的发票金额，号码包含的话费金额为运营商收取，发票可在运营商系统开取。")])])], -1);

var _hoisted_98 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "7.5rem",
    "height": "2.0rem",
    "margin": "0 auto"
  }
}, null, -1);

var _hoisted_99 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "7.5rem",
    "height": "0.1rem",
    "margin": "0 auto",
    "position": "fixed",
    "bottom": "0"
  }
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_swipe_item = _resolveComponent("van-swipe-item");

  var _component_van_swipe = _resolveComponent("van-swipe");

  var _component_van_notice_bar = _resolveComponent("van-notice-bar");

  var _component_van_image = _resolveComponent("van-image");

  var _component_van_col = _resolveComponent("van-col");

  var _component_van_row = _resolveComponent("van-row");

  var _component_van_search = _resolveComponent("van-search");

  var _component_van_switch = _resolveComponent("van-switch");

  var _component_van_cell = _resolveComponent("van-cell");

  var _component_van_button = _resolveComponent("van-button");

  var _component_van_picker = _resolveComponent("van-picker");

  var _component_van_popup = _resolveComponent("van-popup");

  var _component_van_area = _resolveComponent("van-area");

  var _component_van_action_sheet = _resolveComponent("van-action-sheet");

  var _component_van_list = _resolveComponent("van-list");

  var _component_van_nav_bar = _resolveComponent("van-nav-bar");

  var _component_van_field = _resolveComponent("van-field");

  var _component_van_checkbox = _resolveComponent("van-checkbox");

  var _component_van_cell_group = _resolveComponent("van-cell-group");

  var _component_van_icon = _resolveComponent("van-icon");

  var _component_van_form = _resolveComponent("van-form");

  var _component_van_cascader = _resolveComponent("van-cascader");

  var _component_UnicomInNetProtocol = _resolveComponent("UnicomInNetProtocol");

  var _component_TelcomNetProtocol = _resolveComponent("TelcomNetProtocol");

  var _component_BroadNetProtocol = _resolveComponent("BroadNetProtocol");

  var _component_MobileNetProtocol = _resolveComponent("MobileNetProtocol");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_swipe, {
    autoplay: 3000,
    "lazy-render": ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_swipe_item, null, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('../assets/images/main.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_1)];
        }),
        _: 1
      }), _createVNode(_component_van_swipe_item, null, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('../assets/images/unicom_bsp.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_2)];
        }),
        _: 1
      }), _createVNode(_component_van_swipe_item, null, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('../assets/images/mobile_bsp_gzh.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_3)];
        }),
        _: 1
      }), _createVNode(_component_van_swipe_item, null, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('../assets/images/telcom_bsp.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_4)];
        }),
        _: 1
      }), _createVNode(_component_van_swipe_item, null, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('../assets/images/broadnet_bsp.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_5)];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_van_notice_bar, {
    "left-icon": require('../assets/images/laba.png'),
    text: "靓号有保底消费，有在网合约要求，请根据自己的实际消费情况，理性消费。"
  }, null, 8, ["left-icon"]), _createVNode(_component_van_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_col, {
        span: "24"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("article", _hoisted_6, [_createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return $options.loadData(1);
            })
          }, [_createVNode(_component_van_image, {
            src: require('../assets/images/select_lh.png')
          }, null, 8, ["src"]), _hoisted_7]), _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return $options.goPage(1);
            })
          }, [_createVNode(_component_van_image, {
            src: require('../assets/images/select_tc.png')
          }, null, 8, ["src"]), _hoisted_8]), _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return $options.goPage(2);
            })
          }, [_createVNode(_component_van_image, {
            src: require('../assets/images/gexingdingzhi.png')
          }, null, 8, ["src"]), _hoisted_9]), _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return $options.goPage(3);
            })
          }, [_createVNode(_component_van_image, {
            src: require('../assets/images/query_order.png')
          }, null, 8, ["src"]), _hoisted_10])])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_van_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_col, {
        span: "24"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_search, {
            modelValue: $data.queryObj.keyNum,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return $data.queryObj.keyNum = $event;
            }),
            modelModifiers: {
              tirm: true
            },
            background: "#F8EFCC",
            label: "模糊查询",
            placeholder: "输入您想要的号码或者喜欢的数字",
            shape: "round",
            "show-action": ""
          }, {
            action: _withCtx(function () {
              return [_createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = function ($event) {
                  return $options.loadData(1);
                })
              }, "搜索")];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_van_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_col, {
        span: "6"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            center: "",
            title: "尾号"
          }, {
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_switch, {
                modelValue: $data.queryObj.trail,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return $data.queryObj.trail = $event;
                }),
                size: "16px",
                onChange: _cache[7] || (_cache[7] = function ($event) {
                  return $options.loadData(1);
                })
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "7"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            center: "",
            title: "不含4"
          }, {
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_switch, {
                modelValue: $data.queryObj.exclude,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
                  return $data.queryObj.exclude = $event;
                }),
                size: "16px",
                onChange: _cache[9] || (_cache[9] = function ($event) {
                  return $options.loadData(1);
                })
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "11"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            center: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_button, {
                block: "",
                color: "#4169E1",
                round: "",
                type: "mini",
                onClick: $options.clear
              }, {
                default: _withCtx(function () {
                  return [_hoisted_11];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_van_row, {
    justify: "space-between"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_col, {
        class: "van-hairline--surround",
        span: "8"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            title: $data.optName,
            "arrow-direction": "down",
            "is-link": "",
            onClick: _cache[10] || (_cache[10] = function ($event) {
              return $data.optShow = true;
            })
          }, null, 8, ["title"]), _createVNode(_component_van_popup, {
            show: $data.optShow,
            "onUpdate:show": _cache[12] || (_cache[12] = function ($event) {
              return $data.optShow = $event;
            }),
            position: "bottom",
            round: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_picker, {
                columns: $data.optIds,
                style: {
                  "width": "7.5rem",
                  "margin": "0 auto"
                },
                title: "请选择运营商",
                onCancel: _cache[11] || (_cache[11] = function ($event) {
                  return $data.optShow = false;
                }),
                onConfirm: $options.confirmOpt
              }, null, 8, ["columns", "onConfirm"])];
            }),
            _: 1
          }, 8, ["show"])];
        }),
        _: 1
      }), _createVNode(_component_van_col, {
        class: "van-hairline--surround",
        span: "8"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            title: $data.ascriptionArea,
            "arrow-direction": "down",
            "is-link": "",
            onClick: _cache[13] || (_cache[13] = function ($event) {
              return $data.ascriptionAreaShow = true;
            })
          }, null, 8, ["title"]), _createVNode(_component_van_popup, {
            show: $data.ascriptionAreaShow,
            "onUpdate:show": _cache[16] || (_cache[16] = function ($event) {
              return $data.ascriptionAreaShow = $event;
            }),
            position: "bottom",
            round: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_picker, {
                modelValue: $data.ascriptionAreaCode,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
                  return $data.ascriptionAreaCode = $event;
                }),
                columns: $data.ascriptionList,
                title: "请选择号码归属地",
                onCancel: _cache[15] || (_cache[15] = function ($event) {
                  return $data.ascriptionAreaShow = false;
                }),
                onConfirm: $options.confirmAscription
              }, null, 8, ["modelValue", "columns", "onConfirm"])];
            }),
            _: 1
          }, 8, ["show"])];
        }),
        _: 1
      }), _createVNode(_component_van_col, {
        class: "van-hairline--surround",
        span: "8"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            title: $data.rule,
            "arrow-direction": "down",
            "is-link": "",
            onClick: _cache[17] || (_cache[17] = function ($event) {
              return $data.ruleShow = true;
            })
          }, null, 8, ["title"]), _createVNode(_component_van_action_sheet, {
            show: $data.ruleShow,
            "onUpdate:show": _cache[19] || (_cache[19] = function ($event) {
              return $data.ruleShow = $event;
            }),
            style: {
              height: '45%'
            },
            position: "bottom"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_area, {
                "area-list": $data.rulesList,
                "columns-num": 2,
                "columns-placeholder": ['主规律', '子规律'],
                title: "请选择号码规律",
                onCancel: _cache[18] || (_cache[18] = function ($event) {
                  return $data.ruleShow = false;
                }),
                onConfirm: $options.rulesConfirm
              }, null, 8, ["area-list", "onConfirm"])];
            }),
            _: 1
          }, 8, ["show"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_list, {
    modelValue: $data.loading,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
      return $data.loading = $event;
    }),
    finished: $data.finished,
    "finished-text": $data.result,
    onLoad: $options.loadData
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("article", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item,
          class: "phonelist",
          onClick: function onClick($event) {
            return $options.openOrder(item);
          }
        }, [_createElementVNode("span", _hoisted_15, [_createElementVNode("span", {
          innerHTML: item.display
        }, null, 8, _hoisted_16), item.onlineMonths != 0 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "靓")) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_18, [item.optId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "中国移动")) : item.optId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_20, "中国联通")) : item.optId == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_21, "中国电信")) : item.optId == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_22, "中国广电")) : item.optId == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_23, "民营运营商")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.area), 1)]), _createElementVNode("span", _hoisted_24, "￥" + _toDisplayString(item.costPrice + item.fee) + " （含话费￥" + _toDisplayString(item.fee) + "）", 1)], 8, _hoisted_14);
      }), 128))])];
    }),
    _: 1
  }, 8, ["modelValue", "finished", "finished-text", "onLoad"]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_van_image, {
    src: require('../assets/images/loading.gif'),
    style: {
      "width": "0.5rem"
    }
  }, null, 8, ["src"]), _hoisted_26])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_27, [_hoisted_28, _hoisted_29, _createElementVNode("span", null, [_createElementVNode("a", _hoisted_30, [$data.fullPath.indexOf('52tongxun.com') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_31, "浙ICP备19034816号-6")) : $data.fullPath.indexOf('52tongxun.cn') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_32, "浙ICP备19034816号-5")) : $data.fullPath.indexOf('52tongxin.cn') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_33, "浙ICP备19034816号-4")) : $data.fullPath.indexOf('52kuandai.com') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_34, "浙ICP备19034816号-3")) : (_openBlock(), _createElementBlock("span", _hoisted_35, "浙ICP备19034816号-1"))])])], 512), [[_vShow, $data.showCopyright]]), _createVNode(_component_van_popup, {
    show: $data.showBsp,
    "onUpdate:show": _cache[21] || (_cache[21] = function ($event) {
      return $data.showBsp = $event;
    }),
    position: "bottom"
  }, null, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[35] || (_cache[35] = function ($event) {
      return $data.show = $event;
    }),
    position: "bottom",
    style: {
      "height": "100%"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_nav_bar, {
        "left-arrow": "",
        "left-text": "返回",
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        },
        title: "立即预约",
        onClickLeft: _cache[22] || (_cache[22] = function ($event) {
          return $data.show = false;
        })
      }), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString($data.phoneObj.phoneNumber), 1), _hoisted_39, _createElementVNode("span", _hoisted_40, _toDisplayString($data.phoneObj.province), 1), _createElementVNode("span", _hoisted_41, _toDisplayString($data.phoneObj.area), 1), $data.phoneObj.optId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_42, "中国移动")) : $data.phoneObj.optId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_43, "中国联通")) : $data.phoneObj.optId == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_44, "中国电信")) : $data.phoneObj.optId == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_45, "民营运营商")) : $data.phoneObj.optId == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_46, "中国广电")) : _createCommentVNode("", true)]), _createElementVNode("table", _hoisted_47, [_createElementVNode("tr", null, [_hoisted_48, _createElementVNode("td", null, _toDisplayString($data.phoneObj.product.userProductName), 1)]), _createElementVNode("tr", null, [_hoisted_49, _createElementVNode("td", null, _toDisplayString($data.phoneObj.product.monthFee) + " 元/月", 1)]), $data.phoneObj.product.packageOther ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [_hoisted_51, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.phoneObj.product.packageOther.split(/[;；]/), function (item, index) {
        return _openBlock(), _createElementBlock("p", {
          key: 'other_' + index
        }, _toDisplayString(item), 1);
      }), 128))])])) : _createCommentVNode("", true), _createElementVNode("tr", null, [_hoisted_52, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.phoneObj.product.inPackageContent.split(/[;；]/), function (item, index) {
        return _openBlock(), _createElementBlock("p", {
          key: 'in_' + index
        }, _toDisplayString(item), 1);
      }), 128))])]), _createElementVNode("tr", null, [_hoisted_53, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.phoneObj.product.outPackageFee.split(/[;；]/), function (item, index) {
        return _openBlock(), _createElementBlock("p", {
          key: 'out_' + index
        }, _toDisplayString(item), 1);
      }), 128))])]), $data.phoneObj.lowConsume != 0 || $data.phoneObj.onlineMonths != 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [_hoisted_55, _createElementVNode("td", null, [$data.phoneObj.lowConsume != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_56, [_hoisted_57, _createElementVNode("span", _hoisted_58, _toDisplayString($data.phoneObj.lowConsume), 1), _hoisted_59])) : _createCommentVNode("", true), $data.phoneObj.onlineMonths != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_60, [_hoisted_61, _createElementVNode("span", _hoisted_62, _toDisplayString($data.phoneObj.onlineMonths), 1), _hoisted_63])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), _hoisted_64, _createVNode(_component_van_form, {
        onSubmit: $options.submitOrder
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_field, {
                modelValue: $data.orderObj.userInfo.userName,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
                  return $data.orderObj.userInfo.userName = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写真实姓名',
                  validator: $options.nameValidator
                }],
                label: "真实姓名",
                name: "姓名",
                placeholder: "请输入开户人真实姓名",
                required: ""
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                modelValue: $data.orderObj.userInfo.idCard,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) {
                  return $data.orderObj.userInfo.idCard = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写身份证号',
                  validator: $options.idCardValidator
                }],
                label: "身份证号",
                name: "身份证号",
                placeholder: "请输入开户人真实身份证",
                required: ""
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                modelValue: $data.areaStr,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = function ($event) {
                  return $data.areaStr = $event;
                }),
                "is-link": "",
                label: "收货地址",
                name: "收货地址",
                placeholder: "请选择收货的省 / 城市 / 区县",
                readonly: "",
                required: "",
                onClick: _cache[26] || (_cache[26] = function ($event) {
                  return $data.addressShow = true;
                })
              }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
                modelValue: $data.orderObj.userInfo.address,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = function ($event) {
                  return $data.orderObj.userInfo.address = $event;
                }),
                rules: [{
                  required: true,
                  message: '请输入正确的收货详细地址'
                }],
                label: "详细地址",
                name: "详细地址",
                placeholder: "请输入收货的详细地址",
                required: ""
              }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
                modelValue: $data.orderObj.userInfo.phone,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = function ($event) {
                  return $data.orderObj.userInfo.phone = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写联系电话',
                  validator: $options.phoneValidator
                }],
                label: "联系电话",
                name: "联系电话",
                placeholder: "请输入开户人真实联系电话",
                required: "",
                type: "tel"
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                rules: [{
                  required: true,
                  message: '请阅读并勾选'
                }],
                name: "checkbox"
              }, {
                input: _withCtx(function () {
                  return [_createVNode(_component_van_checkbox, {
                    modelValue: $data.orderObj.checked,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = function ($event) {
                      return $data.orderObj.checked = $event;
                    }),
                    shape: "square"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_65, $data.phoneObj.optId == 2 ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[29] || (_cache[29] = function ($event) {
                          return $data.showUnicomProtocol = true;
                        })
                      }, [_hoisted_66, _hoisted_67, _hoisted_68, $data.phoneObj.lowConsume > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_69, _hoisted_72)) : _createCommentVNode("", true)])) : $data.phoneObj.optId == 3 ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: _cache[30] || (_cache[30] = function ($event) {
                          return $data.showTelcomProtocol = true;
                        })
                      }, _hoisted_76)) : $data.phoneObj.optId == 5 ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        onClick: _cache[31] || (_cache[31] = function ($event) {
                          return $data.showBroadProtocol = true;
                        })
                      }, _hoisted_78)) : $data.phoneObj.optId == 1 ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        onClick: _cache[32] || (_cache[32] = function ($event) {
                          return $options.loadProtocol();
                        })
                      }, _hoisted_84)) : _createCommentVNode("", true)];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("span", _hoisted_87, [_hoisted_88, _createElementVNode("span", _hoisted_89, "￥ " + _toDisplayString($data.phoneObj.costPrice + $data.phoneObj.fee), 1)]), _createElementVNode("span", {
            style: {
              "font-size": "0.2rem",
              "color": "#F37B1D"
            },
            onClick: _cache[34] || (_cache[34] = function ($event) {
              return $data.showPriceDetail = !$data.showPriceDetail;
            })
          }, [_hoisted_90, $data.showPriceDetail ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            name: "arrow-up"
          })) : (_openBlock(), _createBlock(_component_van_icon, {
            key: 1,
            name: "arrow-down"
          }))]), _createVNode(_component_van_button, {
            class: "pay_btn",
            "native-type": "submit",
            disabled: $data.submitBtnFlag
          }, {
            default: _withCtx(function () {
              return [_hoisted_91];
            }),
            _: 1
          }, 8, ["disabled"]), _withDirectives(_createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, [_hoisted_94, _createElementVNode("span", null, "￥ " + _toDisplayString($data.phoneObj.costPrice), 1)]), _createElementVNode("div", _hoisted_95, [_hoisted_96, _createElementVNode("span", null, "￥ " + _toDisplayString($data.phoneObj.fee), 1)])], 512), [[_vShow, $data.showPriceDetail]])])])];
        }),
        _: 1
      }, 8, ["onSubmit"]), _hoisted_97, _createElementVNode("div", null, [$data.phoneObj.optId == 1 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        src: require('../assets/images/mobile_bsp_gzh.png')
      }, null, 8, ["src"])) : $data.phoneObj.optId == 2 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 1,
        src: require('../assets/images/unicom_bsp.png')
      }, null, 8, ["src"])) : $data.phoneObj.optId == 3 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 2,
        src: require('../assets/images/telcom_bsp.png')
      }, null, 8, ["src"])) : $data.phoneObj.optId == 5 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 3,
        src: require('../assets/images/broadnet_bsp.png')
      }, null, 8, ["src"])) : _createCommentVNode("", true)]), _hoisted_98])];
    }),
    _: 1
  }, 8, ["show"]), _hoisted_99, _createElementVNode("div", {
    class: "goTop",
    onClick: _cache[36] || (_cache[36] = function () {
      return $options.backtop && $options.backtop.apply($options, arguments);
    })
  }, [_createVNode(_component_van_icon, {
    name: "back-top"
  })]), _createVNode(_component_van_popup, {
    show: $data.addressShow,
    "onUpdate:show": _cache[39] || (_cache[39] = function ($event) {
      return $data.addressShow = $event;
    }),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_cascader, {
        modelValue: $data.addressCascaderValue,
        "onUpdate:modelValue": _cache[37] || (_cache[37] = function ($event) {
          return $data.addressCascaderValue = $event;
        }),
        options: $data.addressOptions,
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        },
        title: "请选择收货地址的 省 / 市 / 区县",
        onClose: _cache[38] || (_cache[38] = function ($event) {
          return $data.addressShow = false;
        }),
        onFinish: $options.confirmAddress
      }, null, 8, ["modelValue", "options", "onFinish"])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_UnicomInNetProtocol, {
    showUnicomProtocol: $data.showUnicomProtocol,
    "onUpdate:showUnicomProtocol": _cache[40] || (_cache[40] = function ($event) {
      return $data.showUnicomProtocol = $event;
    }),
    "ad-order": $data.orderObj
  }, null, 8, ["showUnicomProtocol", "ad-order"]), _createVNode(_component_TelcomNetProtocol, {
    showTelcomProtocol: $data.showTelcomProtocol,
    "onUpdate:showTelcomProtocol": _cache[41] || (_cache[41] = function ($event) {
      return $data.showTelcomProtocol = $event;
    })
  }, null, 8, ["showTelcomProtocol"]), _createVNode(_component_BroadNetProtocol, {
    showBroadProtocol: $data.showBroadProtocol,
    "onUpdate:showBroadProtocol": _cache[42] || (_cache[42] = function ($event) {
      return $data.showBroadProtocol = $event;
    })
  }, null, 8, ["showBroadProtocol"]), _createVNode(_component_MobileNetProtocol, {
    showMobileProtocol: $data.showMobileProtocol,
    "onUpdate:showMobileProtocol": _cache[43] || (_cache[43] = function ($event) {
      return $data.showMobileProtocol = $event;
    }),
    protocolContent: $data.protocol[$data.queryObj.provinceCode]
  }, null, 8, ["showMobileProtocol", "protocolContent"])]);
}